import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { updateSEO, seoConfigs } from '../../utils/seo';

const ServicesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    updateSEO(seoConfigs.services);
  }, []);

  const services = [
    {
      title: '全身脱毛コース',
      price: '月額 9,800円〜',
      description: '最新の脱毛機器を使用した、痛みの少ない全身脱毛。20代女性の肌質に合わせた丁寧な施術で、ツルツルの美肌を実現します。',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/9cd24c2d1b6a72cfb41d061e73ee79cc.jpeg',
      features: ['全身22部位対応', '痛みを最小限に抑えた施術', '肌質に合わせた出力調整', '施術後のアフターケア付き'],
    },
    {
      title: '部分脱毛プラン',
      price: '1部位 3,500円〜',
      description: '気になる部位だけを集中ケア。顔、VIO、腕、脚など、お好きな部位を選んで施術できます。',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/32ff02af17bc10581642faca78eca3ca.jpeg',
      features: ['顔・VIO・腕・脚など選択可能', '1部位から施術OK', '短時間で完了', '組み合わせ割引あり'],
    },
    {
      title: 'フェイシャルエステ',
      price: '60分 8,000円〜',
      description: 'お肌の悩みに合わせたオーダーメイドケア。毛穴ケア、美白、保湿など、透明感のある美肌へ導きます。',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/9b848f1e8b9556842bf6ff838810fc78.jpeg',
      features: ['肌質診断カウンセリング', '毛穴ケア・クレンジング', '美白・保湿トリートメント', 'フェイスマッサージ'],
    },
    {
      title: '美白フェイシャル',
      price: '90分 12,000円〜',
      description: '透明感のある明るい肌を目指す、美白に特化したスペシャルケア。岡山市で人気の春の新メニューです。',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/e365475b6eb0458efeb02bbb6c9c8ec8.jpeg',
      features: ['ビタミンC導入', 'ホワイトニングパック', 'リフトアップマッサージ', '美容液プレゼント'],
    },
    {
      title: '痩身ボディケア',
      price: '90分 15,000円〜',
      description: '理想のボディラインを目指す専門的なプログラム。マッサージとマシンを組み合わせた効果的なアプローチ。',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/b04799364ec40a3598bbce747630e4d2.jpeg',
      features: ['キャビテーション施術', 'リンパドレナージュ', 'セルライトケア', '食事アドバイス付き'],
    },
    {
      title: 'ブライダルコース',
      price: '3ヶ月プラン 98,000円〜',
      description: '人生で最も美しい日のために。結婚式に向けた総合的な美容プログラムで、完璧な花嫁姿を実現します。',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/4c9ba47253787c6f0cf694b936b8b64a.jpeg',
      features: ['脱毛・フェイシャル・痩身の総合ケア', '式直前の集中ケア', 'ドレス映えボディメイク', '当日メイクサポート'],
    },
  ];

  const pricingPlans = [
    {
      name: 'ライトプラン',
      price: '月額 5,980円',
      period: '6ヶ月コース',
      features: [
        '部分脱毛（3部位選択）',
        '月1回施術',
        '施術後のアフターケア',
        'LINE予約対応',
      ],
      recommended: false,
    },
    {
      name: 'スタンダードプラン',
      price: '月額 9,800円',
      period: '12ヶ月コース',
      features: [
        '全身脱毛（22部位）',
        '月2回施術',
        '施術後のアフターケア',
        'LINE予約優先対応',
        'フェイシャルエステ1回無料',
      ],
      recommended: true,
    },
    {
      name: 'プレミアムプラン',
      price: '月額 19,800円',
      period: '12ヶ月コース',
      features: [
        '全身脱毛（22部位）',
        '月3回施術',
        '施術後のアフターケア',
        'LINE予約優先対応',
        'フェイシャルエステ月1回',
        '痩身ボディケア月1回',
        '美容ドリンクプレゼント',
      ],
      recommended: false,
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[30vh] md:h-[35vh] w-full overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://public.readdy.ai/ai/img_res/58928ac39eb426fe04ae31a96e39be6a.jpg"
            alt="岡山市の脱毛サロン・エステのサービス"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="text-center px-6">
            <p className="text-white text-xs md:text-sm font-light mb-4 tracking-widest uppercase">
              Services &amp; Pricing
            </p>
            <h1 className="text-white text-4xl md:text-6xl lg:text-7xl font-bold">
              サービス・料金案内
            </h1>
          </div>
        </div>
      </section>

      {/* Services Grid Section */}
      <section className="py-20 md:py-28 bg-gray-light px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16">
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold text-gray-dark mb-4 md:mb-0">
              全サービス一覧
            </h2>
            <p className="text-sm md:text-base font-light text-gray-medium">
              岡山市で20代女性に人気のメニュー
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
            {services.map((service, index) => (
              <article key={index} className="bg-white rounded-lg overflow-hidden hover:shadow-xl transition-shadow">
                <div className="h-56 w-full overflow-hidden">
                  <img
                    src={service.image}
                    alt={`岡山市の${service.title}`}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl md:text-2xl font-bold text-gray-dark mb-2">
                    {service.title}
                  </h3>
                  <p className="text-lg font-medium text-gray-medium mb-4">
                    {service.price}
                  </p>
                  <p className="text-sm md:text-base font-light text-gray-dark/80 leading-relaxed mb-4">
                    {service.description}
                  </p>
                  <ul className="space-y-2 mb-6">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start text-sm font-light text-gray-dark/70">
                        <i className="ri-check-line mr-2 mt-0.5 text-gray-dark w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <a
                    href="/contact"
                    className="block w-full px-6 py-2.5 bg-[#8C646E] text-white text-sm text-center font-light rounded-full whitespace-nowrap hover:bg-[#7A5660] transition-colors cursor-pointer"
                  >
                    このプランを予約
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Plans Section */}
      <section className="py-20 md:py-28 bg-white px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-gray-medium text-xs md:text-sm font-light mb-4 tracking-widest uppercase">
              Pricing
            </p>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-gray-dark mb-6">
              料金プラン
            </h2>
            <p className="text-base md:text-lg font-light text-gray-dark/80 max-w-3xl mx-auto leading-relaxed">
              お客様のニーズに合わせた3つのプランをご用意しています
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {pricingPlans.map((plan, index) => (
              <article
                key={index}
                className={`rounded-lg overflow-hidden ${
                  plan.recommended
                    ? 'bg-[#8C646E] text-white shadow-2xl transform md:scale-105'
                    : 'bg-gray-light text-gray-dark'
                }`}
              >
                {plan.recommended && (
                  <div className="bg-gray-dark text-white text-center py-2 text-sm font-medium">
                    おすすめ
                  </div>
                )}
                <div className="p-8">
                  <h3 className="text-2xl font-bold mb-2">{plan.name}</h3>
                  <p className={`text-sm font-light mb-6 ${plan.recommended ? 'text-gray-light/80' : 'text-gray-medium'}`}>
                    {plan.period}
                  </p>
                  <div className="mb-8">
                    <p className="text-4xl md:text-5xl font-bold mb-2">{plan.price}</p>
                    <p className={`text-sm font-light ${plan.recommended ? 'text-gray-light/60' : 'text-gray-medium'}`}>
                      税込価格
                    </p>
                  </div>
                  <ul className="space-y-4 mb-8">
                    {plan.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start text-sm font-light">
                        <i className={`ri-check-line mr-3 mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0 ${
                          plan.recommended ? 'text-white' : 'text-gray-dark'
                        }`}></i>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <a
                    href="/contact"
                    className={`block w-full px-6 py-3 text-sm text-center font-medium rounded-full whitespace-nowrap transition-colors cursor-pointer ${
                      plan.recommended
                        ? 'bg-white text-gray-dark hover:bg-gray-light'
                        : 'bg-[#8C646E] text-white hover:bg-[#7A5660]'
                    }`}
                  >
                    このプランを選ぶ
                  </a>
                </div>
              </article>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-sm font-light text-gray-dark/70 leading-relaxed">
              ※表示価格は全て税込です。初回カウンセリングは無料です。<br />
              ※分割払いのご相談も承っております。お気軽にお問い合わせください。
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 md:py-28 px-6" style={{ backgroundColor: '#8C646E' }}>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
            まずは無料カウンセリングから
          </h2>
          <p className="text-base md:text-lg font-light text-gray-light/80 mb-10 leading-relaxed">
            お気軽にお問い合わせください
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:086-012-3456"
              className="px-8 py-3.5 bg-white text-gray-dark text-sm md:text-base font-medium rounded-full whitespace-nowrap hover:bg-gray-light transition-colors cursor-pointer inline-flex items-center"
            >
              <i className="ri-phone-line mr-2 w-5 h-5 flex items-center justify-center"></i>
              086-012-3456
            </a>
            <a
              href="/contact"
              className="px-8 py-3.5 bg-transparent border-2 border-white text-white text-sm md:text-base font-medium rounded-full whitespace-nowrap hover:bg-white hover:text-gray-dark transition-colors cursor-pointer"
            >
              お問い合わせフォーム
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;